import { render, staticRenderFns } from "./ManualForm.vue?vue&type=template&id=1da60960&scoped=true&"
import script from "./ManualForm.vue?vue&type=script&lang=js&"
export * from "./ManualForm.vue?vue&type=script&lang=js&"
import style0 from "./ManualForm.vue?vue&type=style&index=0&id=1da60960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da60960",
  null
  
)

export default component.exports